module.exports = __webpack_public_path__ + "static/media/ionic.73385a69.svg";